var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointmentCheckMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49694 7.50479C3.3713 7.50479 3.24567 7.45671 3.14997 7.36101L0.143965 4.35492C-0.0479882 4.16305 -0.0479882 3.85284 0.143965 3.66097C0.335827 3.46911 0.645953 3.46911 0.837906 3.66097L3.49694 6.32L9.16215 0.654883C9.35401 0.463021 9.66414 0.463021 9.85609 0.654883C10.048 0.846836 10.048 1.15696 9.85609 1.34891L3.844 7.36101C3.74829 7.45671 3.62257 7.50479 3.49694 7.50479Z",
    fill: "#0087CE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentCheckMark);
export default __webpack_public_path__ + "static/media/appointmentCheckMark.272532ae555dddb3dd341e935b823776.svg";
export { ForwardRef as ReactComponent };